import { render, staticRenderFns } from "./IconCaution.vue?vue&type=template&id=6333c7a5"
import script from "./IconCaution.vue?vue&type=script&lang=js"
export * from "./IconCaution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports